module.exports = __webpack_public_path__ + "img/diffuser_1.5cf67af2.svg";